// extracted by mini-css-extract-plugin
module.exports = {"userMessageScreen":"UserMessage_userMessageScreen__330OW","container":"UserMessage_container__8zi91","userMessagePrompt":"UserMessage_userMessagePrompt__2CJj1"};